<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="dollar-sign"/>
          {{ $t('planOrder') }}
        </h1>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <form-select :model="filterFormModel" attribute="group" class="mr-1" @input="load" :options="[
                    {value: 'day', text: $t('byDay')},
                    {value: 'week', text: $t('byWeek')},
                    {value: 'month', text: $t('byMonth')},
                    {value: 'client', text: $t('byClient')},
                    {value:'sales',text:$t('bySales')},
                    {value:'account',text:$t('byAccounts')}]">
              </form-select>
              <client-select :model="filterFormModel"  attribute="client" @input="load" :isFilter="true" :place-holder="$t('selectClient')"
                             class="mr-1"></client-select>
              <admin-user-select :model="filterFormModel" attribute="sales" @input="load" :place-holder="$t('selectSales')" class="mr-1"></admin-user-select>
              <admin-user-select :model="filterFormModel" attribute="account" @input="load" :place-holder="$t('selectAccount')" class="mr-1"></admin-user-select>
              <form-select :model="filterFormModel" attribute="clientsActive1Year" class="mr-1" @input="load" :options="timeRangeOptions"></form-select>
              <time-range-picker ref="timeRangePicker" :model="filterFormModel" @input="load" :label="$t('time')" :default-shortcut="6" class="mr-1"></time-range-picker>
              <button @click="load" class="btn btn-primary mr-1">{{ $t('search') }}</button>
              <button @click="reset" class="btn btn-secondary mr-1">Reset</button>
              <plan-order-export :data="data" :sum="sum" :avg="avg" :label="label" :group="filterFormModel.group"
                              v-if="['admin', 'owner', 'account', 'operationsManager', 'salesAssistant', 'accountant', 'manager', 'tech'].includes($store.state.user.role)"></plan-order-export>

            </div>
          </div>
          <div class="tile">
            <div class="row">
              <div class="col">
                <div>
                  <apexchart :height="300" :options="chartOptions" :series="chartData"></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="tile">
            <div class="table-responsive c-template-table">
              <table class="table table-hover table-bordered">
                <thead>
                <tr>
                  <th></th>
                  <th v-if="filterFormModel.group === 'client'" >{{$t('sales')}}</th>
                  <th v-if="filterFormModel.group === 'client'">{{$t('businessCategory')}}</th>
                  <th v-if="filterFormModel.group === 'client'">{{$t('source')}}</th>
                  <th class="text-center">{{ $t('new') }}</th>
                  <th class="text-center">{{ $t('newUser') }}</th>
                  <th class="text-center">{{ $t('user') }}</th>
                  <th class="text-center">{{ $t('additionalUser') }}</th>
                  <th class="text-center">{{ $t('extend') }}</th>
                  <th class="text-center">{{ $t('extendTotal') }}</th>
                  <th class="text-center">{{ $t('extendMonth') }}</th>
                  <th class="text-center">{{ $t('extendedUser') }}</th>
                  <th class="text-center">{{ $t('upgrade') }}</th>
                  <th class="text-center">{{ $t('total') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="bg-success">
                  <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                  <td v-if="filterFormModel.group === 'client'" ></td>
                  <td v-if="filterFormModel.group === 'client'" ></td>
                  <td v-if="filterFormModel.group === 'client'" ></td>
                  <td class="text-center"><span class="text-blue">{{ sum.new | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.newUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.user | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.additionalUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extend | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extendTotal | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extendMonth | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.extendedUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.upgrade | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ sum.total | numFormat }}</span></td>
                </tr>
                <tr class="bg-warning">
                  <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                  <td v-if="filterFormModel.group === 'client'" ></td>
                  <td v-if="filterFormModel.group === 'client'" ></td>
                  <td v-if="filterFormModel.group === 'client'" ></td>
                  <td class="text-center"><span class="text-blue">{{ avg.new  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.newUser  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.user  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.additionalUser  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extend  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extendTotal  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extendMonth  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.extendedUser  | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.upgrade | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ avg.total | numFormat }}</span></td>
                </tr>
                <tr :key="index" v-for="(item, index) in data">
                  <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                  <td v-if="filterFormModel.group === 'client'" >{{item.clientSales}}</td>
                  <td v-if="filterFormModel.group === 'client'" >{{item.clientCategory}}</td>
                  <td v-if="filterFormModel.group === 'client'" class="text-center" >
                    <span v-if="!item.clientUtmSource" class="badge badge-primary">Tự nhiên</span>
                    <span v-else-if="item.clientUtmSource && item.clientUtmSource === 'sales'" class="badge badge-success">NVKD tự tìm</span>
                    <span v-else class="badge badge-warning">Marketing</span>
                  </td>
                  <td class="text-center"><span class="text-blue">{{ item.new | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.newUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.user | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.additionalUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extend | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extendTotal | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extendMonth | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.extendedUser | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.upgrade | numFormat }}</span></td>
                  <td class="text-center"><span class="text-blue">{{ item.total | numFormat }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import ClientSelect from "../../components/ClientSelect";
import AdminUserSelect from "@/components/AdminUserSelect";
import PlanOrderExport from "@/views/report/PlanOrderExport";

export default {
  components: {AdminUserSelect, ClientSelect, TimeRangePicker, 'apexchart': VueApexCharts, PlanOrderExport},
  data: function () {
    return {
      filterFormModel: {
        group: 'day',
        client: null,
        sales: null,
        account: null,
        clientsActive1Year: null,
      },
      loading: true,
      data: [],
      chartOptions: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'line'
        }
      },
      chartData: [],
      sum: 0,
      avg: 0
    }
  },
  computed: {
    timeRangeOptions() {
      return [
        {value: null, text: this.$t('allClient')},
        {value: true, text: this.$t('last1Year', [moment().subtract(1, 'year').format('DD/MM/YY')])},
      ]
    }
  },
  methods: {
    load() {
      let loader = this.$loading.show();
      this.loading = true;
      if (!this.filterFormModel.to || !this.filterFormModel.from) {
        this.filterFormModel.from = moment().startOf('month').format('x');
        this.filterFormModel.to = moment().endOf('month').format('x');
      }
      this.$service.get('/report/plan-order', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
          for (let key in item) {
            if (!['label', 'clientSales', 'clientCategory', 'clientCareTime'].includes(key)) {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
        this.chartOptions = {
          xaxis: {
            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
            labels: {
              rotate: 0
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          chart: {
            zoom: {
              enabled: false
            },
            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
          }
        };
        this.chartData = [
          {
            name: this.$t('new'),
            data: this.data.map(d => d.new).slice(0, 99).reverse(),
          },
          {
            name: this.$t('user'),
            data: this.data.map(d => d.user).slice(0, 99).reverse(),
          },
          {
            name: this.$t('extend'),
            data: this.data.map(d => d.extend).slice(0, 99).reverse(),
          },
          {
            name: this.$t('upgrade'),
            data: this.data.map(d => d.upgrade).slice(0, 99).reverse(),
          },
          {
            name: this.$t('total'),
            data: this.data.map(d => d.total).slice(0, 99).reverse(),
          }
        ];
      }).finally(() => {
        loader.hide();
        this.loading = false;
      });
    },
    label(item) {
      if (item.label || item.clientSales || item.clientCategory) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        if (this.filterFormModel.group === 'day') {
          return moment(item._id, 'x').format('ll');
        }
        if (this.filterFormModel.group === 'week') {
          return `${moment(item._id, 'x').format('ll')} --> ${moment(item._id, 'x').add(6, 'day').format('ll')}`;
        }
        if (this.filterFormModel.group === 'month') {
          return moment(item._id, 'x').startOf('month').format('MM/YYYY');
        }
      }
    },
    reset() {
      this.filterFormModel = {
        group: 'day',
        client: null,
        clientsActive1Year: null,
      };
      this.load()
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        planOrder : 'Plan order',
        byDay: 'By day',
        byWeek: 'By week',
        byMonth: 'By month',
        byClient: 'By client',
        bySales: 'By sales',
        byAccounts: 'By supporter',
        new: 'New',
        user: 'Buy more user',
        extend: 'Extend',
        upgrade: 'Upgrade',
        totals: 'Total',
        average: 'Average',
        selectSales: 'Select BD',
        selectAccount: 'Select AM',
        newUser: 'New user count',
        additionalUser: 'Additional user count',
        extendedUser: 'Extended user count',
        source: "Client source",
        extendTotal: "Extend order",
        extendMonth: "Extend months",
        companySource: "Company source",
        selfFindingSource: "Self-finding source",
        last1Month: "last 1 month (from {0})",
        last6Month: "last 6 month (from {0})",
        last1Year: "Customers activated within the last 1 year (from {0})",
        allClient: "All customers",
      },
      vi: {
        planOrder : 'Đơn hàng gói dịch vụ',
        byDay: 'Theo ngày',
        byWeek: 'Theo tuần',
        byMonth: 'Theo tháng',
        byClient: 'Theo client',
        bySales: 'Theo sales',
        byAccounts: 'Theo chăm sóc',
        new: 'Mua mới',
        user: 'Mua thêm',
        extend: 'Gia hạn',
        upgrade: 'Nâng cấp',
        totals: 'Tổng',
        average: 'Trung bình',
        selectSales: 'Chọn BD',
        selectAccount: 'Chọn AM',
        newUser: 'Số user mới',
        additionalUser: 'Số user mua thêm',
        extendedUser: 'Số user gia hạn',
        source: "Nguồn khách hàng",
        extendTotal: "Số gói gia hạn",
        extendMonth: "Số tháng gia hạn",
        companySource: "Nguồn công ty",
        selfFindingSource: "Nguồn tự tìm",
        last1Month: "1 tháng gần nhất (từ {0})",
        last6Month: "6 tháng gần nhất (từ {0})",
        last1Year: "KH kích hoạt 1 năm gần nhất (từ {0})",
        allClient: "Tất cả khách hàng",
      }
    }
  }
}
</script>
